export const EVENT_NAMES = {
  COMMAND_OPEN: 'kjb:copyMagic:command:open',
  CALLBACK_OPEN: 'kjb:copyMagic:callback:open',
  CALLBACK_CLOSE: 'kjb:copyMagic:callback:close',
} as const;
